import { DefaultError, useQuery } from '@tanstack/react-query';
import { listQueryKeys } from 'constants/queryKey';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ITrackLight } from './types';

export const useGetTrackLightList = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ITrackLight[], DefaultError>({
    queryKey: [listQueryKeys.tracksLightList],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Track/LightList`,
      });

      return responseHandler(response, {
        groupName: `useGetTrackLightList`,
      });
    },
  });
};
